<div class="list-input-container" (click)="focusInput($event)">
  @for (item of itemList; track item; let i = $index) {
    <div class="list-item" [ngClass]="{ invalid: !validateItem(item), frozen: frozen }">
      {{ item }}
      @if (!frozen) {
        <button class="delete-button" type="button" (click)="removeItem(i)">
          <svg lucideX></svg>
        </button>
      }
    </div>
  }
  <input
    id="handle-inp"
    #inputField
    class="spacer"
    type="text"
    [(ngModel)]="currentItem"
    (keydown)="handleKeyDown($event)"
    (paste)="handleClipboardPaste($event)"
    [placeholder]="itemList.length > 0 ? '' : placeholderText"
    (blur)="addItem()"
    [disabled]="this.frozen"
  />
</div>
